<template>
    <div @click="onPagerClick" class="box-group">
        <div
            :class="{ 'box-active': currentPage === 1 }"
            v-if="pageCount > 0"
            class="box box-page">1</div>

        <div
            class="box-ellipsis el-icon more btn-quickprev"
            :class="[quickprevIconClass]"
            v-if="showPrevMore"
            @mouseenter="quickprevIconClass = 'el-icon-d-arrow-left'"
            @mouseleave="quickprevIconClass = 'el-icon-more'">
        </div>

        <div
            :key="'page' + key"
            v-for="(pager, key) in pagers"
            :class="{ 'box-active': currentPage === pager }"
            class="box box-page">{{ pager }}</div>

        <div
            class="box-ellipsis el-icon more btn-quicknext"
            :class="[quicknextIconClass]"
            v-if="showNextMore"
            @mouseenter="quicknextIconClass = 'el-icon-d-arrow-right'"
            @mouseleave="quicknextIconClass = 'el-icon-more'">
        </div>

        <div
        :class="{ 'box-active': currentPage === pageCount }"
        class="box box-page"
        v-if="pageCount > 1">{{ pageCount }}</div>
    </div>
</template>

<script type="text/javascript">
export default {
    name: 'Pager',
    data: function () {
        return {
            current: null,
            showPrevMore: false,
            showNextMore: false,
            quicknextIconClass: 'el-icon-more',
            quickprevIconClass: 'el-icon-more'
        }
    },
    props: {
        currentPage: Number,
        pageCount: Number
    },

    watch: {
        showPrevMore: function (val) {
            if (!val) this.quickprevIconClass = 'el-icon-more'
        },

        showNextMore: function (val) {
            if (!val) this.quicknextIconClass = 'el-icon-more'
        }
    },

    computed: {
        pagers: function () {
            var pagerCount = 7

            var currentPage = Number(this.currentPage)
            var pageCount = Number(this.pageCount)

            var showPrevMore = false
            var showNextMore = false

            if (pageCount > pagerCount) {
                if (currentPage > pagerCount - 3) {
                    showPrevMore = true
                }

                if (currentPage < pageCount - 3) {
                    showNextMore = true
                }
            }

            var array = []
            var i
            if (showPrevMore && !showNextMore) {
                var startPage = pageCount - (pagerCount - 2)
                for (i = startPage; i < pageCount; i++) {
                    array.push(i)
                }
            } else if (!showPrevMore && showNextMore) {
                for (i = 2; i < pagerCount; i++) {
                    array.push(i)
                }
            } else if (showPrevMore && showNextMore) {
                var offset = Math.floor(pagerCount / 2) - 1
                for (i = currentPage - offset; i <= currentPage + offset; i++) {
                    array.push(i)
                }
            } else {
                for (i = 2; i < pageCount; i++) {
                    array.push(i)
                }
            }

            /* eslint-disable */
            this.showPrevMore = showPrevMore
            this.showNextMore = showNextMore

            return array
        }
    },

    methods: {
        onPagerClick: function (event) {
            var target = event.target
            if (target.tagName === 'UL') {
                return
            }

            var newPage = Number(event.target.textContent)
            var pageCount = this.pageCount
            var currentPage = this.currentPage

            if (target.className.indexOf('more') !== -1) {
                if (target.className.indexOf('quickprev') !== -1) {
                    newPage = currentPage - 5
                } else if (target.className.indexOf('quicknext') !== -1) {
                    newPage = currentPage + 5
                }
            }

            /* istanbul ignore if */
            if (!isNaN(newPage)) {
                if (newPage < 1) {
                    newPage = 1
                }

                if (newPage > pageCount) {
                    newPage = pageCount
                }
            }

            if (newPage !== currentPage) {
                this.$emit('change', newPage)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../../scss/common/pagination.scss';
</style>



// WEBPACK FOOTER //
// src/components/lib/pager.vue